import React, { useState, useEffect } from "react";
import "./Keyword.css";
import { ROOT_ID } from "relay-runtime";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { useTheme, useThemeUpdate } from "../contexts/ThemeContext";

let id = "";
let value = "";

function Keyword(props) {
	const [isChecked, setIsChecked] = useState(false);
	const [isTagClicked, setIsTagClicked] = useState(false);
	const [selectedId, setSelectedId] = useState("");
	const [selectedValue, setSelectedValue] = useState("");
	const { tagData } = props.settings;
	const theme = useTheme();

	function onTagClick(e) {
		e.preventDefault();
		setIsChecked(!isChecked);
		setIsTagClicked(true);

		id = e.target.dataset.id;
		value = e.target.dataset.value;
		updataTagList(id, value);
	}

	function updataTagList(id, value) {
		const tagDataObject = JSON.parse(tagData);
		if (tagDataObject[id]) {
			delete tagDataObject[id];
			let tagDataString = JSON.stringify(tagDataObject);
			commitLocalUpdate(environment, store => {
				const record = store.getRoot().getLinkedRecord("settings");
				record.setValue(tagDataString, "tagData");
			});
		} else {
			const tagDataObject = JSON.parse(tagData);
			tagDataObject[id] = value;
			let tagDataString = JSON.stringify(tagDataObject);

			commitLocalUpdate(environment, store => {
				const record = store.getRoot().getLinkedRecord("settings");
				record.setValue(tagDataString, "tagData");
			});
		}
	}

	useEffect(() => {
		if (isTagClicked) {
			// console.log(tagData);
		}
	});

	let highlight = isChecked ? "checked" : "not-checked";
	return (
		<div className="tag-btn-container">
			<div
				id={`tag-btn`}
				className={`keyword-btn theme-${theme.paragraph} theme-${theme.tagOverlay}-${highlight}`}
				data-value={props.value}
				data-id={props.id}
				onClick={onTagClick}
			>
				{props.value}
			</div>
		</div>
	);
}

export default Keyword;
